
/**
 * --- External Imports ---
 */
import { Field, Input, useFieldState } from "@ngt/forms-core";
import dayjs from "dayjs";
import { FC } from "react";

/**
 * --- Internal Imports ---
 */
import { DateFormField, IFormField } from "../../../../api/dtos/dtos";
import InputDateField from "../InputDateField";
import TextFieldControlLabel from "../labels/TextFieldControlLabel";
import { IFormFieldComponentProps } from "../types/FieldTypes";
import FieldErrors from "../utils/FieldErrors";


/**
 * --- Input Field ---
 */
interface IInputFieldDateProps {
    field: IFormField;
}

const InputFieldDate: FC<IInputFieldDateProps> = ({
    field
}) => {

    const { errors, touched } = useFieldState({ errors: true, touched: true });

    return (
        <TextFieldControlLabel 
            field={field}
            control={
                <Input 
                    component={InputDateField}
                    maxDate={dayjs()}
                    format='DD/MM/YYYY'
                    hasErrors={!!errors && touched}
                    sx={{
                        width: '100%',
                        "& input": {
                            padding: '8px 15px',
                        },
                    }}
                />
            }
        />
    )
}

/**
 * --- Date Field Export ---
 */
const FormFieldDate: FC<IFormFieldComponentProps<DateFormField>> = ({
    field,
    form
}) => {
    return (
        <Field propertyPath={`${form.name}.${field.name}`}>
            <InputFieldDate field={field} />
            <FieldErrors />
        </Field>
    );
};

export default FormFieldDate;